import _ from 'underscore';
import { BaseSurvey } from '../base-survey';
import { surveyStatus } from '../survey-status';
import { FactorySurveyView } from './factory-view';
import { validateRSALLMTriggerCondition } from '../utils';

export class RSALLMSuggestionMostWantedSurvey extends BaseSurvey {
  getSurveyName = () => 'RSALLMSuggestionMostWantedSurvey';

  getSurveyId = isTestEnv => isTestEnv ? // eslint-disable-line no-confusing-arrow
    'd68eb6ff-553d-4416-8463-d81dd1006b42' : 'b13b0f87-d533-4915-a6b2-5301c31d0fb1';

  getInitializationConfig = () => ({
    initGroup: 1,
    initStartDate: '2023-02-20',
    initEndDate: '2023-05-31',
  });

  validateTriggerCondition = () => validateRSALLMTriggerCondition(this);

  onSurveySubmit = () => {
    const newSurveyState = {
      status: surveyStatus.SUBMIT,
      nextShownDate: this.SurveyPreferenceService.getDaysAfter(90),
      allCountOfRSASuggestionAPI: 0,
    };
    this.SurveyPreferenceService.setSurveyState({
      surveyName: this.getSurveyName(),
      surveyState: newSurveyState,
    });
  };

  getCallCountOfRSASuggestionAPI = () => {
    const surveyState = this.SurveyPreferenceService.getSurveyState({
      surveyName: this.getSurveyName(),
    });
    if (!_.isEmpty(surveyState)) {
      const { callCountOfRSASuggestionAPI } = surveyState;
      return !_.isUndefined(callCountOfRSASuggestionAPI) ? callCountOfRSASuggestionAPI : 0;
    }
    return 0;
  };

  /*
  * Callback called when dismissing a survey, update the survey trigger condition / user governance
  */
  onSurveyDismiss = () => {
    const surveyState = this.SurveyPreferenceService.getSurveyState({
      surveyName: this.getSurveyName(),
    });

    let newSurveyState = {};
    if (!_.isEmpty(surveyState)) {
      const { status } = surveyState;
      switch (status) {
        case surveyStatus.FIRST_DISMISS:
          // set new state to second-dismiss and next shown date to 14 days
          newSurveyState = {
            status: surveyStatus.SECOND_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(14),
          };
          break;
        case surveyStatus.SECOND_DISMISS:
          // set new state to third-dismiss and next shown date to 30 days
          newSurveyState = {
            status: surveyStatus.THIRD_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(30),
          };
          break;
        case surveyStatus.THIRD_DISMISS:
          // set new state to fourth-dismiss and next shown date to 180 days
          newSurveyState = {
            status: surveyStatus.FOURTH_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(180),
          };
          break;
        case surveyStatus.FOURTH_DISMISS:
          // set new state to fourth-dismiss and next shown date to 180 days
          newSurveyState = {
            status: surveyStatus.FOURTH_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(180),
          };
          break;
        case surveyStatus.INIT:
        case surveyStatus.SUBMIT:
        default:
          // new cycle, set new state to first-dismiss and next shown date to 7 days
          newSurveyState = {
            status: surveyStatus.FIRST_DISMISS,
            nextShownDate: this.SurveyPreferenceService.getDaysAfter(7),
          };
          break;
      }
    } else {
      // new cycle, set new state to first-dismiss and next shown date to 7 days
      newSurveyState = {
        status: surveyStatus.FIRST_DISMISS,
        nextShownDate: this.SurveyPreferenceService.getDaysAfter(7),
      };
    }

    this.SurveyPreferenceService.setSurveyState({
      surveyName: this.getSurveyName(),
      surveyState: _.defaults(newSurveyState, { callCountOfRSASuggestionAPI: 0 }),
    });
  };

  getSurveyComponent = () => FactorySurveyView;

  getSurveyCustomParams = () => window.survey.RSALLMSuggestionCustomParams;
}

